import { computed as v, createElementBlock as o, openBlock as a, createElementVNode as s, createCommentVNode as l, normalizeClass as m, unref as u, createBlock as c, createVNode as w, renderSlot as C, toDisplayString as f, mergeProps as k } from "vue";
import b from "../../atoms/image-element/image-element.vue.js";
import x from "../../atoms/video-element/video-element.vue.js";
import { useGrid as S } from "../../composables/useGrid.js";
import { themeProp as z } from "../../composables/useTheme.js";
import D from "../../molecules/breadcrumbs/breadcrumbs.vue.js";
import B from "../../molecules/eyebrow/eyebrow.vue.js";
import j from "../../molecules/link-back/link-back.vue.js";
import $ from "../../molecules/link/link.vue.js";
import { screenProp as A, isScreenSmall as g, isScreenLarge as y } from "../../utils/utilsScreen.js";
/* empty css                     */
import E from "../../_virtual/_plugin-vue_export-helper.js";
const N = { class: "ds-background-color-white" }, O = {
  key: 0,
  class: "ds-text-medium ds-rich-text"
}, L = {
  key: 0,
  class: "ds-buttons-wrapper ds-margin-top-24"
}, V = { key: 1 }, W = {
  key: 0,
  class: "ds-container ds-padding-x-0",
  "data-j-vertical--media": ""
}, I = /* @__PURE__ */ Object.assign({
  name: "DsHeroWithMedia"
}, {
  __name: "hero-with-media",
  props: {
    ...z,
    ...A,
    title: {
      type: String,
      default: ""
    },
    eyebrow: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: null
    },
    aspectRatio: {
      type: String,
      default: null
    },
    icon: {
      type: Object,
      default: null
    },
    video: {
      type: Object,
      default: null
    },
    description: {
      type: String,
      default: ""
    },
    links: {
      type: Array,
      required: !0
    },
    navigationData: {
      type: [Object, Array],
      default: null,
      validator: (e) => Array.isArray(e) ? e.every((n, i, r) => i === r.length - 1 ? "title" in n : ["title", "url"].every((d) => d in n)) : ["text", "url"].every((n) => n in e)
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    alignCenter: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const n = e, i = v(() => n.screen);
    S(i);
    const r = v(() => {
      var t;
      return !((t = n.links) != null && t.length) > 0 ? null : n.links[0];
    }), d = v(() => {
      var t;
      return !((t = n.links) != null && t.length) > 1 ? null : n.links[1];
    }), h = v(() => Array.isArray(n.navigationData));
    return (t, P) => (a(), o("section", N, [
      s("div", {
        class: m(["ds-container", [
          { "ds-padding-top-48": !e.image && !e.video },
          { "wds-container--snap-right": !e.vertical },
          `ds-hero-with-media--${t.theme}`
        ]])
      }, [
        s("div", {
          class: m(["wds-grid", [
            {
              "wds-grid--snap-right-container": (e.image || e.video) && !u(g)(i.value) && u(y)(i.value) && !e.vertical
            },
            { "ds-align-items-center ds-justify-content-center ds-flex-direction-column": e.vertical && e.alignCenter }
          ]])
        }, [
          e.navigationData && e.vertical && e.alignCenter ? (a(), o("div", {
            key: 0,
            class: m({ "wds-grid__col ds-padding-top-48": e.alignCenter }),
            "data-j-vertical-align-breadcrumb": ""
          }, [
            h.value ? (a(), c(D, {
              key: 1,
              theme: t.theme,
              crumbs: e.navigationData,
              "tracking-data": { "component-name": t.$options.name, title: e.title }
            }, null, 8, ["theme", "crumbs", "tracking-data"])) : (a(), c(j, {
              key: 0,
              theme: t.theme,
              "tracking-data": { "component-name": t.$options.name, text: e.navigationData.text, title: e.title },
              text: e.navigationData.text,
              url: e.navigationData.url,
              nuxt: e.navigationData.nuxt
            }, null, 8, ["theme", "tracking-data", "text", "url", "nuxt"]))
          ], 2)) : l("", !0),
          s("div", {
            class: m(["wds-grid__col wds-grid__col--12 ds-display-flex ds-flex-direction-column", [
              e.vertical ? "wds-md-grid__col--12  wds-lg-grid__col--8 ds-padding-bottom-48 ds-md-padding-bottom-96" : "wds-md-grid__col--6  wds-lg-grid__col--7",
              { "ds-padding-x-12": u(g)(i.value) },
              e.navigationData ? "ds-justify-content-space-between ds-padding-bottom-48 ds-md-padding-bottom-96" : "ds-align-items-center ds-justify-content-center"
            ]])
          }, [
            e.navigationData && !e.alignCenter ? (a(), o("div", {
              key: 0,
              class: m([
                u(g)(i.value) && !e.vertical ? "ds-margin-top-24" : "ds-margin-top-48",
                { "ds-margin-bottom-48": !u(y)(i.value) && !e.vertical }
              ])
            }, [
              h.value ? (a(), c(D, {
                key: 1,
                theme: t.theme,
                crumbs: e.navigationData,
                "tracking-data": { "component-name": t.$options.name, title: e.title }
              }, null, 8, ["theme", "crumbs", "tracking-data"])) : (a(), c(j, {
                key: 0,
                theme: t.theme,
                "tracking-data": { "component-name": t.$options.name, text: e.navigationData.text, title: e.title },
                text: e.navigationData.text,
                url: e.navigationData.url,
                nuxt: e.navigationData.nuxt
              }, null, 8, ["theme", "tracking-data", "text", "url", "nuxt"]))
            ], 2)) : l("", !0),
            s("div", {
              class: m(["ds-hero-with-media--eyebrow", {
                "ds-lg-padding-right-144 ds-padding-bottom-48 ds-md-padding-bottom-96 ds-lg-padding-y-48": !e.vertical,
                "ds-display-flex ds-flex-direction-column ds-align-items-center ds-text-align-center": e.vertical && e.alignCenter,
                "ds-padding-right-24": !u(g)(i.value) && !e.vertical && !e.alignCenter,
                "ds-padding-top-48": e.vertical,
                "ds-md-padding-top-96": e.vertical && !e.navigationData,
                "ds-sm-padding-top-24 ds-sm-margin-top-24 ds-md-padding-top-48 ds-md-margin-top-48 ds-lg-margin-top-0": !u(y)(i.value) && !e.navigationData && !e.vertical
              }]),
              "data-j-content-block": ""
            }, [
              w(B, {
                icon: e.icon,
                text: e.eyebrow
              }, null, 8, ["icon", "text"]),
              s("div", null, [
                e.title ? (a(), o("h1", {
                  key: 0,
                  class: m(["ds-heading-xlarge ds-margin-bottom-12", { "ds-margin-top-12": e.eyebrow || e.icon }])
                }, f(e.title), 3)) : l("", !0)
              ]),
              C(t.$slots, "description", {}, () => [
                e.description ? (a(), o("div", O, f(e.description), 1)) : l("", !0)
              ], !0),
              r.value || d.value ? (a(), o("div", L, [
                w($, {
                  url: r.value.url,
                  "open-in-new-window": r.value.openInNewWindow,
                  nuxt: r.value.nuxt,
                  "lazy-url-endpoint": r.value.lazyUrlEndpoint,
                  content: r.value.title,
                  "tracking-data": { "component-name": t.$options.name, text: r.value.title, title: e.title },
                  type: "button",
                  variant: "primary"
                }, null, 8, ["url", "open-in-new-window", "nuxt", "lazy-url-endpoint", "content", "tracking-data"]),
                d.value ? (a(), c($, {
                  key: 0,
                  url: d.value.url,
                  "open-in-new-window": d.value.openInNewWindow,
                  "lazy-url-endpoint": d.value.lazyUrlEndpoint,
                  nuxt: d.value.nuxt,
                  content: d.value.title,
                  "icon-right": { category: "arrows", name: "chevron-right-small" },
                  "tracking-data": { "component-name": t.$options.name, text: d.value.title, title: e.title },
                  variant: "secondary"
                }, null, 8, ["url", "open-in-new-window", "lazy-url-endpoint", "nuxt", "content", "tracking-data"])) : l("", !0)
              ])) : l("", !0)
            ], 2),
            e.navigationData && !e.vertical ? (a(), o("div", V)) : l("", !0)
          ], 2),
          !e.vertical && (e.image || e.video) ? (a(), o("div", {
            key: 1,
            class: m(["wds-grid__col wds-grid__col--12 wds-md-grid__col--6 wds-lg-grid__col--5", { "wds-grid__col--no-gutter": u(g)(i.value) }]),
            "data-j-horizontal--media": ""
          }, [
            e.video ? (a(), c(x, k({ key: 0 }, e.video, {
              screen: i.value,
              class: "ds-hero-with-media--video",
              "full-height": ""
            }), null, 16, ["screen"])) : e.image ? (a(), c(b, {
              key: 1,
              class: "ds-hero-with-media--image",
              screen: i.value,
              image: e.image,
              "aspect-ratio": e.aspectRatio,
              style: { height: "100% !important" }
            }, null, 8, ["screen", "image", "aspect-ratio"])) : l("", !0)
          ], 2)) : l("", !0)
        ], 2)
      ], 2),
      e.vertical && (e.image || e.video) ? (a(), o("div", W, [
        e.video ? (a(), c(x, k({ key: 0 }, e.video, {
          screen: i.value.name,
          class: "ds-hero-with-media--video",
          "full-height": ""
        }), null, 16, ["screen"])) : e.image ? (a(), c(b, {
          key: 1,
          image: e.image,
          screen: i.value,
          class: "ds-hero-with-media--image",
          "aspect-ratio": e.aspectRatio,
          style: { height: "100% !important" }
        }, null, 8, ["image", "screen", "aspect-ratio"])) : l("", !0)
      ])) : l("", !0)
    ]));
  }
}), Y = /* @__PURE__ */ E(I, [["__scopeId", "data-v-c8fecc07"]]);
export {
  Y as default
};
